import common from './common/link'

export default {
  "name": "Link 7",
  "slug": "link-7",
  "level": 7,
  "assets": {
    "logo": "/themes/link/link-logo.svg",
    "favicon": "/themes/link/link-fav.png"
  },
  "hasRoleSwitch": true,
  "login": {
    "type": "guardTeacherOnly"
  },
  "dbok": [
    {
      "bookId": "6465e86c2f001e0013eb6d4e",
    },
    {
      "bookId": "64670bb32f001e0013eba325",
    },
    {
      "bookId": "6465ddef2f001e0013eb6224",
    },
    {
      "bookId": "646605182f001e0013eb8194",
    },
    {
      "bookId": "65017e55446dbd0013591883",
    }
  ],
  addons: {
    overview: {
      extra: {
        title: 'Writing',
        items: [
          {
            title: 'Writing tool',
            cover:
              '/img/writingtool-cover.svg',
            url: 'https://barnetrinn.skriveverktoy.no/?lang=en-GB',
          },
        ],
      },
    },
  },
  ...common
}
